import {createContext} from 'react';
import {DEFAULT_DEBUG_BOUNDARY_VISIBLE} from 'src/internal/constants';

import type {Dispatch, SetStateAction} from 'react';

type DebugBoundaryVisibleContextType = readonly [
  visibleCategories: Set<string>,
  setVisibleCategories: Dispatch<SetStateAction<Set<string>>>,
];

export default createContext<DebugBoundaryVisibleContextType>(
  DEFAULT_DEBUG_BOUNDARY_VISIBLE,
);
